/**
 * Settings persistence — both editor (zap.editor.*) and player transport
 * (zap.player*) live here so a future build can unify the settings UI.
 */

const lsGet = (key, def) => {
  try {
    const v = localStorage.getItem(key);
    return v === null ? def : v;
  } catch { return def; }
};
const lsSet = (key, val) => {
  try { localStorage.setItem(key, val); } catch { /* noop */ }
};

export function loadEditorSettings() {
  const get = (k, def) => lsGet('zap.editor.' + k, def);
  return {
    arrowPlayingStep:   parseFloat(get('arrowPlayingStep', '10')) || 10,
    arrowPausedStep:    parseFloat(get('arrowPausedStep',  '1'))  || 1,
    frameStep:          parseInt(get('frameStep', '1')) || 1,
    defaultMode:        get('defaultMode', 'skip'),
    defaultRepeatCount: parseInt(get('defaultRepeatCount', '3')) || 3,
    showRegions:        get('showRegions', '1') === '1',
  };
}

export function saveEditorSetting(key, value) {
  lsSet('zap.editor.' + key, String(value));
}

/** Per-file region cache key. Path is shortened to 80 chars (last) for brevity. */
export function regionCacheKey(path) {
  return 'zap.skipRegions.' + ((path || '').slice(-80) || document.location.pathname.slice(-80));
}

export function readRegionCache(path) {
  try { return JSON.parse(lsGet(regionCacheKey(path), '[]') || '[]') || []; }
  catch { return []; }
}

export function writeRegionCache(path, regions) {
  try { lsSet(regionCacheKey(path), JSON.stringify(regions)); } catch { /* noop */ }
}

/** Player transport settings — shared with files.js _openPlayer (Build C). */
export function getPlayerSetting(key, def) {
  return lsGet('zap.player' + key, def);
}
export function setPlayerSetting(key, val) {
  lsSet('zap.player' + key, String(val));
}
